import { create } from "zustand";
import { toast } from "react-toastify";
import { createPostPurchaseFeedback, getOnePostPurchaseFeedback, updatePostPurchaseFeedback } from "../api";
// import { GET_ONE_POST } from "./temp";


export const usePastPurchaseFeedbackStore = create((set) => ({
    feedbackData: null,
    loading: false,
    error: null,
    getOnePostPurchaseFeedback: async (caseId) => {
        try {
            set({ loading: true, error: null });
            const response = await getOnePostPurchaseFeedback(caseId);
            // const response = {data:GET_ONE_POST, status:200}
            if (response.status === 200) {
                set({
                    feedbackData: response.data,
                    loading: false
                });
                return response.data;
            } else {
                set({
                    feedbackData: null,
                    loading: false
                });
                return null;
            }
        } catch (error) {
            console.error('Error fetching post purchase: ', error);
        }
    },
    createPostPurchaseFeedback: async (caseId, feedback) => {
        try {
            set({ loading: true, error: null });
            const response = await createPostPurchaseFeedback(caseId, feedback);

            if (response.status === 201 || response.status === 200) {
                set({
                    feedbackData: response.data,
                    loading: false
                });
                toast.success("Feedback created successfully");
                return response.data;
            } else {
                set({ loading: false });
                toast.warning("Unexpected response when creating feedback");
                return null;
            }
        } catch (error) {
            console.error('Error creating post purchase', error);
            set({
                loading: false,
                error: error?.response?.data?.message || 'Error Creating feedback'
            });
            throw error;
        }
    },
    updatePostPurchaseFeedback: async (caseId, feedback) => {
        try {
            set({ loading: true, error: null });
            const response = await updatePostPurchaseFeedback(caseId, feedback);

            if (response.status === 200) {
                set({
                    feedbackData: response.data,
                    loading: false
                });
                toast.success("Post Purchase Feedback updated successfully");
                return response.data;
            }
        } catch (error) {
            console.error('Error updating post purchase', error);
            set({
                loading: false,
                error: error?.response?.data?.message || 'Error Updating feedback'
            });
            throw error;
        }
    },

    clearFeedback: () => {
        set({
            feedbackData: null,
            error: null
        });
    }

}));
